import React from 'react'
import SavedArticlesIcon from '../../../assets/images/saved-articles-icon.svg';
import './mega-menu-mobile.scss'

const MegaMenuMobile = ({ menuOption, setActiveMegaMenuMobile, activeMegaMenuMobile }) => {

    const closeOption = () => {
        let subColumn = document.getElementById('subColumn')
        subColumn.classList.add("__close-option")
        setTimeout(function () {
            setActiveMegaMenuMobile(null)
            subColumn.classList.remove("__close-option")
        }, 150)
    }

    return (
        <div className="f-m-mega-menu-mobile__content-wrapper" id="subColumn">
            <ul className="f-m-mega-menu-mobile__content" >
                <div className="f-m-mega-menu-mobile__option" onClick={() => closeOption()}>
                    <p >{menuOption.nombreDeLaOpcion}</p>
                    <span className="icon-ico-left-arrow "></span>
                </div>
                {menuOption.opcionesSubmenu.map((item, index) => {
                    let initialPath = (process.env.ENVIRONMENT === 'LOCAL' ? "" : menuOption.redireccionDeLaOpcion)
                    let restPath = (item?.redireccionDeLaOpcion !== "/" && menuOption.redireccionDeLaOpcion != item.redireccionDeLaOpcion) ? item.redireccionDeLaOpcion : ""
                    let fullRedirection = initialPath + restPath
                    return (
                        <li key={index} className={item.redireccionDeLaOpcion === "articulos-guardados/" ? "__row" : ""}>
                            {item.redireccionDeLaOpcion != "articulos-guardados/" ?
                                <a href={fullRedirection}>{item.nombreDeLaOpcion}</a>
                                :
                                <>
                                    <img
                                        src={SavedArticlesIcon}
                                        alt={"saved articles icon"}
                                        loading="lazy"
                                    />
                                    <a href={fullRedirection}>{item.nombreDeLaOpcion}</a>
                                </>
                            }
                            {item.opcionesSubmenu &&
                                <ul className="f-m-mega-menu-mobile__sub-column">
                                    {item.opcionesSubmenu.map((subItem, subIndex) => {
                                        let initialPath = (menuOption?.redireccionDeLaOpcion !== "/" && menuOption.redireccionDeLaOpcion != item.redireccionDeLaOpcion ? menuOption.redireccionDeLaOpcion : "")
                                        let restPath = (subItem.redireccionDeLaOpcion && subItem.redireccionDeLaOpcion !== "/" ? subItem.redireccionDeLaOpcion : "")
                                        let fullRedirection = initialPath + item.redireccionDeLaOpcion + restPath
                                        return (
                                            <li key={subIndex} className="f-m-mega-menu-mobile__sub-item">
                                                <div className="f-m-mega-menu-mobile__sub-item-link"
                                                    onClick={() => {
                                                        window.dataLayer = window.dataLayer || [];
                                                        window.dataLayer.push({
                                                            'event': 'trackEvent',
                                                            'eventCategory': 'ui :: menu :: ' + menuOption.nombreDeLaOpcion,
                                                            'eventAction': 'click',
                                                            'eventLabel': item.nombreDeLaOpcion + ' :: ' + subItem.nombreDeLaOpcion
                                                        });

                                                        window.dataLayer = window.dataLayer || [];
                                                        window.dataLayer.push({
                                                            'event': 'trackGA4',
                                                            'event_type': 'user_interaction',
                                                            'section': 'home',
                                                            'action': 'click',
                                                            'element': item.nombreDeLaOpcion + ' :: ' + subItem.nombreDeLaOpcion,
                                                            'flow': menuOption.nombreDeLaOpcion,
                                                            'screen_name': 'home'
                                                        });
                                                        location.href = fullRedirection
                                                    }}
                                                >{subItem.nombreDeLaOpcion}
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            }
                        </li>
                    )
                })}
            </ul>
        </div>

    )
}

export default MegaMenuMobile
